import React from 'react';
import type {
  DestacadoPayload,
  FiguraPayload,
  FormulaDestacadaPayload,
  GlosarioTablaPayload,
  SubtituloPayload,
} from '../../core/types/payloads/guide_editorial.types';
import { ReadingRichText } from '../../core/text/readingRichText';
import { resolveFiguraStudentPlaceholder } from '../../core/print/figuraPlaceholder';

export function SubtituloView({ payload }: { payload: SubtituloPayload }) {
  return (
    <div className="guide-editorial guide-editorial--subtitulo">
      <h2 className="guide-editorial__section-title">{payload.title}</h2>
      {payload.subtitle ? <p className="guide-editorial__section-sub">{payload.subtitle}</p> : null}
    </div>
  );
}

export function DestacadoView({ payload }: { payload: DestacadoPayload }) {
  const tone = payload.tone ?? 'mint';
  return (
    <aside className={`guide-editorial guide-editorial--destacado guide-editorial--${tone}`}>
      <p className="guide-editorial__destacado-label">{payload.title}</p>
      <ReadingRichText text={payload.body} className="guide-editorial__destacado-body" />
    </aside>
  );
}

export function FiguraView({ payload }: { payload: FiguraPayload }) {
  const imageUrl = String(payload.imageUrl || '').trim() || undefined;
  const studentAlt = resolveFiguraStudentPlaceholder(payload);

  return (
    <figure className="guide-editorial guide-editorial--figura">
      {payload.title ? <p className="guide-editorial__figura-title">{payload.title}</p> : null}
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={studentAlt}
          className="guide-editorial__figura-image block h-auto w-full max-h-72 rounded-xl border border-slate-200 object-cover shadow-sm"
        />
      ) : (
        <div className="guide-editorial__figura-placeholder" aria-label={studentAlt}>
          <span className="guide-editorial__figura-icon" aria-hidden>
            🖼
          </span>
          <p className="guide-editorial__figura-alt">{studentAlt}</p>
        </div>
      )}
      <figcaption className="guide-editorial__figura-caption">{payload.caption}</figcaption>
    </figure>
  );
}

export function GlosarioTablaView({ payload }: { payload: GlosarioTablaPayload }) {
  return (
    <div className="guide-editorial guide-editorial--glosario">
      <h3 className="guide-editorial__glosario-title">{payload.title}</h3>
      <dl className="guide-editorial__synthesis-grid">
        {payload.entries.map((entry) => (
          <div key={entry.term} className="guide-editorial__synthesis-card">
            <dt className="guide-editorial__synthesis-term">{entry.term}</dt>
            <dd className="guide-editorial__synthesis-def">{entry.definition}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

/** @deprecated Usar FormulaDestacada.tsx (react-katex) */
export function FormulaDestacadaView({ payload }: { payload: FormulaDestacadaPayload }) {
  return (
    <div className="guide-editorial guide-editorial--formula">
      <p className="guide-editorial__formula-title">{payload.title}</p>
      <div className="guide-editorial__formula-latex" aria-label="Fórmula">
        {payload.latex}
      </div>
      <p className="guide-editorial__formula-desc">{payload.description}</p>
    </div>
  );
}
